import { Button, Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import Header from "../Header/Header";
import "./Profile.scss";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import Typography from "@mui/material/Typography";
import { Link, useNavigate } from "react-router-dom";
import CloseIcon from "@mui/icons-material/Close";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import InputLabel from "@mui/material/InputLabel";
import OutlinedInput from "@mui/material/OutlinedInput";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import upload from "../../Img/upload.jpg";
import Avatar from "@mui/material/Avatar";
import { styled } from "@mui/material/styles";
import NativeSelect from "@mui/material/NativeSelect";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import TextField from "@mui/material/TextField";
import Qr from "../../Img/qr-bar.jpg";
import kyc from "../../Img/kyc-img.png";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import VerifiedUserOutlinedIcon from "@mui/icons-material/VerifiedUserOutlined";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import { useMediaQuery, useTheme } from "@mui/material";
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import VisibilityIcon from '@mui/icons-material/Visibility';
import usercalls from "../../Axios";
import consts from '../../constant';
import axios from "axios";
import ErrorIcon from "@mui/icons-material/Error";
import CameraAltIcon from '@mui/icons-material/CameraAlt';
import { QRCodeSVG } from "qrcode.react";
import { toast, ToastContainer } from 'react-toastify';


function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    "aria-controls": `vertical-tabpanel-${index}`,
  };
}

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

const Profile = () => {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const [edit, setedit] = React.useState(false);
  const [age, setAge] = React.useState("");

  const path = usercalls()
  const [userData, setUserData] = useState({})
  const [secret, setSecret] = useState('')
  const [qrCode, setQrcode] = useState(null)
  const [otp, setOtp] = useState(null)
  const [name, setName] = useState(null)
  const [load, setLoad] = useState(false)
  const token = localStorage.getItem('Rikosta')


  // const handleChange = (event) => {
  //   setAge(Number(event.target.value) || "");
  // };

  // const handleClickOpen = () => {
  //   setedit(true);
  // };

  // const handleClickClose = (event, reason) => {
  //   if (reason !== "backdropClick") {
  //     setedit(false);
  //   }
  // };



  CustomTabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
  };

  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  }

  const [imageUrl, setImageUrl] = useState(null);

  const handleImageUpload = async (event) => {
    const file = event.target.files[0];

    const formdata = new FormData();
    formdata.append("image", file)

    const url = `${consts.BackendUrl}/users/imageUpload`

    const { data } = await axios.post(url, formdata, {
      headers: {
        'Authorization': `${token}`,
      },
    });
    if (data.success) {
      const url = `${consts.BackendUrl}/users/UpdateUser`
      const payload = {
        profilePicture: data.result
      }
      const response = await path.postCall({ url, payload });
      const result = await response.json();
      console.log(result.result.name, 'result.result.name');

      if (result.success) {
        getProfile()
      }
    }
    else {
      console.log('error');
    }
  };

  const [value, setValue] = useState(0);

  const handleValueChange = (event, newValue) => {
    setValue(newValue);
  };

  const [EmailModal, setEmailModal] = useState(false);
  const handleEmailOpen = () => {
    console.log("test");
    setEmailModal(true);
  };
  const handleEmailClose = () => setEmailModal(false);

  const [GoogleModal, setGoogleModal] = useState(false);
  const handleGoogleOpen = () => { setGoogleModal(true); setOtp(null) }
  const handleGoogleClose = () => setGoogleModal(false);

  const [DisableGoogleModal, setDisableGoogleModal] = useState(false);
  const handleDisableGoogleOpen = () => { setDisableGoogleModal(true); setOtp(null) }
  const handleDisableGoogleClose = () => setDisableGoogleModal(false);

  const [ProfileModal, setProfileModal] = useState(false);
  const handleProfileOpen = () => setProfileModal(true);
  const handleProfileClose = () => setProfileModal(false);

  const [PasswordModal, setPasswordModal] = useState(false);
  const handlePasswordOpen = () => setPasswordModal(true);
  const handlePasswordClose = () => setPasswordModal(false);

  const [Kyc, setKyc] = useState(false);
  const handleKycOpen = () => setKyc(true);
  const handleKycClose = () => setKyc(false);

  const [copied, setCopied] = useState(false);

  // const defaultText = "888asdasdewr";
  // const [text, setText] = useState(defaultText);

  const handleCopy = () => {
    navigator.clipboard.writeText(secret).then(
      () => {
        setCopied(true);
        setTimeout(() => setCopied(false), 1000);
      },
      (err) => {
        console.error("Failed to copy text: ", err);
      }
    );
  };



  // const handleSubmit = (event) => {
  //   event.preventDefault();
  //   const data = new FormData(event.currentTarget);
  //   console.log({
  //     email: data.get("email"),
  //     password: data.get("password"),
  //   });
  // };
  // const handleMouseDownPassword = (event) => {
  //     event.preventDefault();
  // };

  // const handleMouseUpPassword = (event) => {
  //     event.preventDefault();
  // };
  const navigate = useNavigate();

  const [show, setShow] = useState(true);
  const [showPassword, setShowPassword] = useState(false);

  const handleClickShowPassword = () => setShowPassword(!showPassword);

  const [showNewPassword, setShowNewPassword] = useState(false);

  const handleClickNewShowPassword = () => setShowNewPassword(!showNewPassword);

  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const handleClickConfirmShowPassword = () => setShowConfirmPassword(!showConfirmPassword);

  const [oldPass, setOldPass] = useState("");
  const [NewPass, setNewPass] = useState("");
  const [ConfirmPass, setConfirmPass] = useState("");

  const passwordRegex = /^(?=.*[A-Z])(?=.*[!@#$%^&*])(?=.*[0-9]).{8,}$/;


  const changePassword = async () => {
    try {
      if (oldPass == '') {
        toast.error('Please Enter Old Password')
      }
      else if (NewPass == '') {
        toast.error('Please Enter New Password')
      }
      else if (NewPass && !passwordRegex.test(NewPass)) {
        toast.error("Password Must Contain MIN 8 Character , One ALPHABET And Must Contain One Number and Special Characters  Eg : Abc@1234")
      }
      else if (oldPass && NewPass && ConfirmPass == "") {
        toast.error("Please Enter Confirm Password")
      }
      else if (ConfirmPass !== NewPass) {
        toast.error("Confirm Password MisMatch")

      }
      else {
        setLoad(true)
        const url = `${consts.BackendUrl}/users/UpdatePassword`
        const payload = {
          // email: userData.email,
          oldpassword: oldPass,
          newpassword: NewPass
        }
        const response = await path.postCall({ url, payload });
        const result = await response.json();
        if (result.success) {
          setLoad(false)
          toast.success(result?.message)
          handlePasswordClose()
        }
        else {
          setLoad(false)
          toast.error(result?.message)
        }
      }
    } catch (error) {
      setLoad(false)
      console.log("🚀 ~ changePassword ~ error:", error);
    } finally {

      setConfirmPass("");
      setOldPass("");
      setNewPass("");

    }
  }


  const generate2fa = async () => {
    try {
      const url = `${consts.BackendUrl}/generate2fa`
      const response = await path.postCallTokenonly({ url });
      const result = await response.json();
      // console.log(result, 'resulyt');
      const authurl = result?.result?.otpauth_url + "&issuer=KaaviExchange"
      if (result.success) {
        setSecret(result.result.secret)
        setQrcode(authurl)
      }
      else {
        setSecret('')
        setQrcode(null)
      }

    } catch (error) {
      console.log("🚀 ~ generate2fa ~ error:", error);

    }
  }

  const verify2fa = async () => {
    try {
      setLoad(true)
      const url = `${consts.BackendUrl}/verify2fa`
      const payload = {
        secret: otp
      }
      const response = await path.postCall({ url, payload });
      const result = await response.json();
      if (result.success) {
        setLoad(false)
        toast.success(result?.message)
        handleGoogleClose()
        getProfile()
      }
      else {
        setLoad(false)
        toast.error(result?.message)
      }
    } catch (error) {
      console.log("🚀 ~ verify2fa ~ error:", error);
    }
  }

  const diable2fa = async () => {
    try {
      setLoad(true)
      const url = `${consts.BackendUrl}/disable2fa`
      const payload = {
        secret: otp
      }
      const response = await path.postCall({ url, payload });
      const result = await response.json();
      if (result.success) {
        toast.success(result.message)
        setLoad(false)
        handleDisableGoogleClose()
        getProfile()
      }
      else {
        toast.error(result.message)
        setLoad(false)
      }
    } catch (error) {
      setLoad(false)
      console.log("🚀 ~ disable2fa ~ error:", error);
    }
  }

  const updateProfile = async () => {
    try {
      if (name == null) {
        toast.error('Please Enter Name')
      }
      else {
        setLoad(true)
        const url = `${consts.BackendUrl}/users/UpdateUser`
        const payload = {
          name: name
        }
        const response = await path.postCall({ url, payload });
        const result = await response.json();
        if (result.success) {
          setLoad(false)
          toast.success(result?.message)
          handleProfileClose()
          getProfile()
        }
      }
    } catch (error) {
      setLoad(false)
      console.log("🚀 ~ updateProfile ~ error:", error);
    }
  }

  const getProfile = async () => {
    try {
      const url = `${consts.BackendUrl}/users/get_profile`
      const response = await path.getCallWithToken({ url });
      const result = await response.json();
      // console.log(result, 'result');
      if (result.success) {
        setName(result.result.name)
        setUserData(result?.result)
      }
      else {
        setUserData({})
      }
    } catch (error) {
      console.log("🚀 ~ getProfile ~ error:", error);
    }
  }

  const getKyc = async () => {
    try {
      const url = `${consts.BackendUrl}/users/mykycdetail`
      const response = await path.getCallWithToken({ url });
      const result = await response.json();
      if (result?.success == true) {
      } else {
        handleOpen()
      }
    } catch (error) {
      console.log("🚀 ~ getKyc ~ error:", error)
    }
  }

  useEffect(() => {
    getProfile()
    getKyc()
  }, [])

  return (
    <>
      <ToastContainer />
      <div className="Profile">
        <Header profile={userData?.profilePicture} />
        <div className="contain-width">
          <Grid container className="justi-center">
            <Grid xs={12} sm={12} md={12} lg={12} xl={12}>
              <div className="modal-popup">
                <Modal
                  aria-labelledby="transition-modal-title"
                  aria-describedby="transition-modal-description"
                  open={open}
                  onClose={handleClose}
                  closeAfterTransition
                  slots={{ backdrop: Backdrop }}
                  slotProps={{
                    backdrop: {
                      timeout: 500,
                    },
                  }}
                >
                  <Fade in={open}>
                    <Box className="id-popup">
                      <div
                        className="close-menu text-end cursor"
                        onClick={() => {
                          handleClose();
                        }}
                      >
                        <CloseIcon />
                      </div>
                      <Typography
                        id="transition-modal-title"
                        variant="h6"
                        component="h2"
                      >
                        Identity Verification Required
                      </Typography>
                      <p id="transition-modal-description" sx={{ mt: 2 }}>
                        To enjoy the full range of our products and services, we
                        kindly request you complete the identity verification
                        process.
                      </p>
                      <div className="verify-know text-center">
                        {/* <Link to="">Verify Now</Link> */}
                        <Link onClick={() => { handleClose(); setValue(1) }}>Verify Now</Link>

                      </div>
                    </Box>
                  </Fade>
                </Modal>
              </div>
            </Grid>

            <Grid xs={12} sm={12} md={12} lg={12} xl={12}>
              <Box>
                <div className="security-tab display-2">
                  <Tabs
                    value={value}
                    onChange={handleValueChange}
                    aria-label="basic tabs example"
                    className=""
                  >
                    <Tab
                      className="display-1 id-verify"
                      icon={
                        <svg
                          width="21"
                          height="20"
                          viewBox="0 0 21 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M15.2538 8.08938C15.3312 8.01198 15.3926 7.9201 15.4345 7.81897C15.4764 7.71785 15.4979 7.60946 15.4979 7.50001C15.4979 7.39055 15.4764 7.28216 15.4345 7.18104C15.3926 7.07991 15.3312 6.98803 15.2538 6.91063C15.1764 6.83323 15.0845 6.77184 14.9834 6.72995C14.8823 6.68806 14.7739 6.6665 14.6644 6.6665C14.555 6.6665 14.4466 6.68806 14.3455 6.72995C14.2443 6.77184 14.1525 6.83323 14.0751 6.91063L9.66444 11.3213L7.33694 8.99376C7.18063 8.83744 6.96862 8.74963 6.74756 8.74963C6.52651 8.74963 6.3145 8.83744 6.15819 8.99376C6.00188 9.15007 5.91406 9.36207 5.91406 9.58313C5.91406 9.80419 6.00188 10.0162 6.15819 10.1725L9.07506 13.0894C9.15244 13.1668 9.24431 13.2283 9.34544 13.2702C9.44657 13.3121 9.55497 13.3337 9.66444 13.3337C9.77391 13.3337 9.88231 13.3121 9.98344 13.2702C10.0846 13.2283 10.1764 13.1668 10.2538 13.0894L15.2538 8.08938Z"
                            fill="#8C8C8C"
                            fill-opacity="0.4"
                          />
                          <path
                            d="M11.6723 1.13937C10.9097 0.916576 10.0993 0.916576 9.33672 1.13937L4.56734 2.53125C3.87511 2.73337 3.26708 3.1545 2.83447 3.73146C2.40186 4.30842 2.168 5.01011 2.16797 5.73125V8.34562C2.16797 10.619 2.82464 12.844 4.05903 14.753C5.29341 16.6621 7.05295 18.174 9.12609 19.1069C9.55888 19.3012 10.0279 19.4017 10.5023 19.4017C10.9768 19.4017 11.4458 19.3012 11.8786 19.1069C13.9511 18.1739 15.7101 16.6622 16.9442 14.7535C18.1782 12.8448 18.8347 10.6204 18.8348 8.3475V5.73062C18.8349 5.00962 18.6012 4.30804 18.1687 3.73117C17.7361 3.15431 17.1282 2.73327 16.4361 2.53125L11.673 1.14L11.6723 1.13937ZM9.80359 2.73937C10.2611 2.60562 10.7473 2.60562 11.2048 2.73937L15.968 4.13062C16.314 4.23174 16.618 4.44233 16.8342 4.7308C17.0505 5.01928 17.1673 5.37009 17.1673 5.73062V8.3475C17.1673 10.2992 16.6036 12.2094 15.544 13.8485C14.4844 15.4875 12.9739 16.7857 11.1942 17.5869C10.9764 17.6848 10.7403 17.7355 10.5014 17.7355C10.2626 17.7355 10.0264 17.6848 9.80859 17.5869C8.02838 16.7856 6.51747 15.4873 5.4575 13.8479C4.39754 12.2085 3.83364 10.2978 3.83359 8.34562V5.73125C3.83359 4.99062 4.32234 4.33875 5.03359 4.13125L9.80297 2.73937H9.80359Z"
                            fill="#8C8C8C"
                            fill-opacity="0.4"
                          />
                        </svg>
                      }
                      label="Dasboard"
                      {...a11yProps(0)}
                    />
                    {/* <Tab
                    className="display-1 id-verify"
                    icon={
                      <svg
                        width="21"
                        height="20"
                        viewBox="0 0 21 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M15.2538 8.08938C15.3312 8.01198 15.3926 7.9201 15.4345 7.81897C15.4764 7.71785 15.4979 7.60946 15.4979 7.50001C15.4979 7.39055 15.4764 7.28216 15.4345 7.18104C15.3926 7.07991 15.3312 6.98803 15.2538 6.91063C15.1764 6.83323 15.0845 6.77184 14.9834 6.72995C14.8823 6.68806 14.7739 6.6665 14.6644 6.6665C14.555 6.6665 14.4466 6.68806 14.3455 6.72995C14.2443 6.77184 14.1525 6.83323 14.0751 6.91063L9.66444 11.3213L7.33694 8.99376C7.18063 8.83744 6.96862 8.74963 6.74756 8.74963C6.52651 8.74963 6.3145 8.83744 6.15819 8.99376C6.00188 9.15007 5.91406 9.36207 5.91406 9.58313C5.91406 9.80419 6.00188 10.0162 6.15819 10.1725L9.07506 13.0894C9.15244 13.1668 9.24431 13.2283 9.34544 13.2702C9.44657 13.3121 9.55497 13.3337 9.66444 13.3337C9.77391 13.3337 9.88231 13.3121 9.98344 13.2702C10.0846 13.2283 10.1764 13.1668 10.2538 13.0894L15.2538 8.08938Z"
                          fill="#8C8C8C"
                          fill-opacity="0.4"
                        />
                        <path
                          d="M11.6723 1.13937C10.9097 0.916576 10.0993 0.916576 9.33672 1.13937L4.56734 2.53125C3.87511 2.73337 3.26708 3.1545 2.83447 3.73146C2.40186 4.30842 2.168 5.01011 2.16797 5.73125V8.34562C2.16797 10.619 2.82464 12.844 4.05903 14.753C5.29341 16.6621 7.05295 18.174 9.12609 19.1069C9.55888 19.3012 10.0279 19.4017 10.5023 19.4017C10.9768 19.4017 11.4458 19.3012 11.8786 19.1069C13.9511 18.1739 15.7101 16.6622 16.9442 14.7535C18.1782 12.8448 18.8347 10.6204 18.8348 8.3475V5.73062C18.8349 5.00962 18.6012 4.30804 18.1687 3.73117C17.7361 3.15431 17.1282 2.73327 16.4361 2.53125L11.673 1.14L11.6723 1.13937ZM9.80359 2.73937C10.2611 2.60562 10.7473 2.60562 11.2048 2.73937L15.968 4.13062C16.314 4.23174 16.618 4.44233 16.8342 4.7308C17.0505 5.01928 17.1673 5.37009 17.1673 5.73062V8.3475C17.1673 10.2992 16.6036 12.2094 15.544 13.8485C14.4844 15.4875 12.9739 16.7857 11.1942 17.5869C10.9764 17.6848 10.7403 17.7355 10.5014 17.7355C10.2626 17.7355 10.0264 17.6848 9.80859 17.5869C8.02838 16.7856 6.51747 15.4873 5.4575 13.8479C4.39754 12.2085 3.83364 10.2978 3.83359 8.34562V5.73125C3.83359 4.99062 4.32234 4.33875 5.03359 4.13125L9.80297 2.73937H9.80359Z"
                          fill="#8C8C8C"
                          fill-opacity="0.4"
                        />
                      </svg>
                    }
                    label="Security"
                    {...a11yProps(1)}
                  /> */}
                    <Tab
                      className="display-1 id-verify"
                      icon={
                        <svg
                          width="21"
                          height="20"
                          viewBox="0 0 21 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M3.65547 6.18062C3.65547 5.62308 3.76529 5.071 3.97865 4.55589C4.19201 4.04079 4.50474 3.57276 4.89898 3.17851C5.29323 2.78427 5.76126 2.47154 6.27636 2.25818C6.79147 2.04481 7.34355 1.935 7.90109 1.935C8.45864 1.935 9.01072 2.04481 9.52582 2.25818C10.0409 2.47154 10.509 2.78427 10.9032 3.17851C11.2974 3.57276 11.6102 4.04079 11.8235 4.55589C12.0369 5.071 12.1467 5.62308 12.1467 6.18062C12.1467 7.30663 11.6994 8.38652 10.9032 9.18273C10.107 9.97894 9.0271 10.4262 7.90109 10.4262C6.77508 10.4262 5.69519 9.97894 4.89898 9.18273C4.10277 8.38652 3.65547 7.30663 3.65547 6.18062ZM7.90172 3.60125C7.21754 3.60125 6.56139 3.87304 6.0776 4.35682C5.59382 4.84061 5.32203 5.49676 5.32203 6.18093C5.32203 6.86511 5.59382 7.52126 6.0776 8.00505C6.56139 8.48884 7.21754 8.76062 7.90172 8.76062C8.58589 8.76062 9.24205 8.48884 9.72583 8.00505C10.2096 7.52126 10.4814 6.86511 10.4814 6.18093C10.4814 5.49676 10.2096 4.84061 9.72583 4.35682C9.24205 3.87304 8.58589 3.60125 7.90172 3.60125ZM1.94922 17.2319C1.94922 13.8831 4.65422 11.5844 7.87797 11.5844C11.0911 11.5844 13.8536 13.8737 13.8536 17.2319C13.8536 17.4528 13.7658 17.6647 13.6096 17.821C13.4533 17.9772 13.2414 18.065 13.0205 18.065C12.7995 18.065 12.5876 17.9772 12.4314 17.821C12.2751 17.6647 12.1873 17.4528 12.1873 17.2319C12.1873 14.9356 10.3192 13.2512 7.87859 13.2512C5.44797 13.2512 3.61609 14.9262 3.61609 17.2319C3.61609 17.4528 3.52832 17.6647 3.37208 17.821C3.21584 17.9772 3.00393 18.065 2.78297 18.065C2.56201 18.065 2.3501 17.9772 2.19386 17.821C2.03762 17.6647 1.94984 17.4528 1.94984 17.2319H1.94922ZM13.5823 8.33312C13.5823 7.87312 13.9555 7.5 14.4155 7.5H19.3473C19.5683 7.5 19.7802 7.58777 19.9365 7.74401C20.0927 7.90026 20.1805 8.11216 20.1805 8.33312C20.1805 8.55408 20.0927 8.76599 19.9365 8.92223C19.7802 9.07847 19.5683 9.16625 19.3473 9.16625H14.4155C14.1945 9.16625 13.9826 9.07847 13.8264 8.92223C13.6701 8.76599 13.5823 8.55408 13.5823 8.33312ZM14.5242 11.6669C14.5242 11.2069 14.8973 10.8337 15.3573 10.8337H18.4042C18.6252 10.8337 18.8371 10.9215 18.9933 11.0778C19.1496 11.234 19.2373 11.4459 19.2373 11.6669C19.2373 11.8878 19.1496 12.0997 18.9933 12.256C18.8371 12.4122 18.6252 12.5 18.4042 12.5H15.3573C15.1364 12.5 14.9245 12.4122 14.7682 12.256C14.612 12.0997 14.5242 11.8878 14.5242 11.6669Z"
                            fill="#8C8C8C"
                            fill-opacity="0.4"
                          />
                        </svg>
                      }
                      label="Identity Verification"
                      {...a11yProps(1)}
                    />
                  </Tabs>

                  {/* <div className="time-zone">
                  <p>Time Zone</p>
                  <div className="time-zone-content display-1">
                    <p>
                      <strong>(UTC+8) Asia/Singapore</strong>
                    </p>
                    <div className="time-zone-modal">
                      <Button onClick={()=>{handleClickOpen()}}>
                        <BorderColorIcon />
                      </Button>
                      <div className="time-zone-pop">
                        <Dialog
                          disableEscapeKeyDown
                          open={edit}
                          onClose={handleClickClose}
                          className="time-zone-pop"
                        >
                          <div
                            className="time-zone-close close-menu text-end cursor"
                            onClick={()=>{handleClickClose()}}
                          >
                            <CloseIcon />
                          </div>
                          <DialogTitle>Change Time Zone</DialogTitle>
                          <DialogContent>
                            <Box
                              component="form"
                              sx={{ display: "flex", flexWrap: "wrap" }}
                            >
                              <FormControl sx={{ m: 1 }} className="coin-value">
                                <InputLabel htmlFor="demo-dialog-native">
                                  Time Zone
                                </InputLabel>
                                <Select
                                  native
                                  value={age}
                                  onChange={handleChange}
                                  input={
                                    <OutlinedInput
                                      label="Time Zone"
                                      id="demo-dialog-native"
                                    />
                                  }
                                  className="select-outline"
                                >
                                  <option aria-label="None" value="" />
                                  <option value={10}>
                                    (UTC+8) Asia/Taipei
                                  </option>
                                  <option value={20}>
                                    (UTC+7) Asia/Bangkok
                                  </option>
                                  <option value={30}>
                                    (UTC+5) Asia/Ashgabat
                                  </option>
                                  <option value={40}>
                                    (UTC+5)(UTC+8) Asia/Taipei
                                  </option>
                                  <option value={50}>
                                    (UTC+5) (UTC+8) Asia/Singapore
                                  </option>
                                </Select>
                              </FormControl>
                            </Box>
                          </DialogContent>
                          <div className="verify-know text-center time-zone-btn">
                            <Link to="">Save</Link>
                          </div>
                        </Dialog>
                      </div>
                    </div>
                  </div>
                </div> */}
                </div>
              </Box>
              <CustomTabPanel value={value} index={0} className="pad_0" >
                <Grid container className="justi-center" >
                  <Grid xs={12} sm={12} md={12} lg={12} xl={12}>
                    <div className="dashboard-full">
                      <Button
                        component="label"
                        role={undefined}
                        tabIndex={-1}
                        startIcon={<CameraAltIcon />}
                        className="pencil-icon"
                      >
                        <VisuallyHiddenInput
                          type="file"
                          onChange={handleImageUpload}
                        />
                      </Button>

                      <div className="profile-change display-2 edit-profile-img">

                        <div className="profile-avatarnew display-1">

                          <Avatar
                            alt="Remy Sharp"
                            // src={userData?.profilePicture ? userData?.profilePicture : imageUrl ? imageUrl : upload}
                            src={userData?.profilePicture ? userData?.profilePicture : upload}
                          />

                          <div>
                            <h5>
                              {/* <strong>Jenny Smith</strong> */}
                              <strong>{userData?.name ? userData?.name : 'Hello User'}</strong>
                            </h5>
                            <span>{userData?.email}</span>
                          </div>

                          <Button
                            onClick={() => {
                              handleProfileOpen();
                            }}
                          >
                            <span>
                              <BorderColorIcon />
                            </span>
                          </Button>

                          <Modal
                            open={ProfileModal}
                            onClose={handleProfileClose}
                            aria-labelledby="modal-modal-title"
                            aria-describedby="modal-modal-description"
                          >
                            <Box className="id-popup setting-popup">
                              <div
                                className="close-menu text-end cursor"
                                onClick={() => {
                                  handleProfileClose();
                                }}
                              >
                                <CloseIcon />
                              </div>
                              <Typography
                                id="modal-modal-title"
                                variant="h6"
                                component="h2"
                              >
                                Settings
                              </Typography>

                              {/* <div className="imp-note display-1">
                                <ErrorIcon />
                                <p>
                                  Note: Your nickname can only be changed once per
                                  month.
                                </p>
                              </div> */}

                              <div className="code-box">
                                <label>Name</label>
                                <TextField fullWidth id="fullWidth"
                                  value={name}
                                  onChange={(e) => {
                                    let value = e.target.value
                                    value = value.replace(/[^A-Za-z]/ig, '')
                                    setName(value)
                                  }}
                                />
                              </div>
                              <div className="submit-btn text-center">
                                {
                                  load ?
                                    <Button sx={{ mt: 2, paddingBottom: "15px" }}>
                                      Processing...
                                    </Button> :
                                    <Button sx={{ mt: 2, paddingBottom: "15px" }} onClick={() => { updateProfile() }}>
                                      Save
                                    </Button>
                                }

                              </div>
                            </Box>
                          </Modal>

                        </div>
                        <div className="verification display-1">
                          <div className="email-box display-1 text-center">
                            {
                              userData?.email_verify === 'true' ?
                                <svg
                                  width="24"
                                  height="24"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M3.43934 4.18934C3.72064 3.90804 4.10217 3.75 4.5 3.75H19.5C19.8978 3.75 20.2794 3.90804 20.5607 4.18934C20.842 4.47065 21 4.85218 21 5.25V10.7531C21 19.1427 13.8772 21.9192 12.4804 22.3836C12.1698 22.4948 11.8302 22.4948 11.5196 22.3836C10.1228 21.9192 3 19.1427 3 10.7531V5.25C3 4.85217 3.15804 4.47064 3.43934 4.18934ZM19.5 5.25L4.5 5.25L4.5 10.7531C4.5 18.0901 10.706 20.534 12 20.9626C13.294 20.534 19.5 18.0901 19.5 10.7531V5.25Z"
                                    fill="#06B470"
                                  />
                                  <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M16.6677 9.2323C16.9536 9.532 16.9424 10.0067 16.6427 10.2927L11.1396 15.5427C10.8496 15.8193 10.3934 15.8191 10.1037 15.5422L7.35684 12.9172C7.05738 12.631 7.0466 12.1563 7.33278 11.8568C7.61895 11.5574 8.0937 11.5466 8.39317 11.8328L10.6223 13.963L15.6073 9.20734C15.907 8.92142 16.3817 8.93259 16.6677 9.2323Z"
                                    fill="#06B470"
                                  />
                                </svg> :
                                // <svg
                                //   width="24"
                                //   height="24"
                                //   viewBox="0 0 24 24"
                                //   fill="none"
                                //   xmlns="http://www.w3.org/2000/svg"
                                // >
                                //   <path
                                //     d="M10.0185 2.6488C10.5932 2.22728 11.2873 2 12 2C12.7127 2 13.4068 2.22728 13.9815 2.6488L15.1417 3.49897C15.3329 3.64025 15.5542 3.73151 15.7893 3.76777L17.2119 3.98656C17.916 4.09491 18.5671 4.42484 19.0709 4.92843C19.5747 5.43203 19.9049 6.08309 20.0136 6.78711L20.2323 8.20989C20.2686 8.44368 20.3599 8.66623 20.5011 8.85751L21.3512 10.0177C21.7727 10.5925 22 11.2866 22 11.9994C22 12.7121 21.7727 13.4063 21.3512 13.981L20.5011 15.1412C20.3616 15.3329 20.2695 15.5548 20.2323 15.7889L20.0136 17.2116C19.9051 17.9159 19.5751 18.5672 19.0713 19.0711C18.5674 19.5749 17.9161 19.905 17.2119 20.0134L15.7893 20.2322C15.5552 20.2694 15.3333 20.3615 15.1417 20.501L13.9815 21.3512C13.4068 21.7727 12.7127 22 12 22C11.2873 22 10.5932 21.7727 10.0185 21.3512L8.85833 20.501C8.66673 20.3615 8.44481 20.2694 8.21075 20.2322L6.78681 20.0147C6.08302 19.9061 5.43213 19.5761 4.92858 19.0725C4.42503 18.5689 4.09503 17.918 3.98644 17.2141L3.76766 15.7914C3.73048 15.5573 3.63836 15.3354 3.49887 15.1437L2.64876 13.9835C2.22726 13.4088 2 12.7146 2 12.0019C2 11.2891 2.22726 10.595 2.64876 10.0202L3.49887 8.86001C3.63836 8.6684 3.73048 8.44646 3.76766 8.21239L3.98644 6.78711C4.09503 6.08327 4.42503 5.43234 4.92858 4.92876C5.43213 4.42519 6.08302 4.09516 6.78681 3.98656L8.2095 3.76777C8.44328 3.73151 8.66581 3.64025 8.85708 3.49897L10.0185 2.6488ZM12.8714 4.16035C12.6185 3.97526 12.3133 3.87548 12 3.87548C11.6867 3.87548 11.3815 3.97526 11.1286 4.16035L9.96848 5.01051C9.53272 5.32936 9.02684 5.53902 8.49329 5.62188L7.0731 5.83942C6.76292 5.88711 6.47603 6.03248 6.25413 6.2544C6.03223 6.47631 5.88687 6.76322 5.83918 7.07342L5.62166 8.49494C5.5388 9.02853 5.32916 9.53444 5.01032 9.97023L4.16021 11.1292C3.77891 11.6481 3.77891 12.3544 4.16021 12.872L5.01032 14.0323C5.33037 14.4674 5.53914 14.9725 5.62166 15.5076L5.83918 16.9278C5.9367 17.5655 6.43676 18.0643 7.0731 18.1618L8.49454 18.3794C9.02836 18.4619 9.53342 18.6707 9.96973 18.9907L11.1286 19.8409C11.6475 20.2222 12.3538 20.2222 12.8714 19.8409L14.0315 18.9907C14.4673 18.6719 14.9732 18.4622 15.5067 18.3794L16.9269 18.1618C17.5645 18.0643 18.0633 17.5642 18.1608 16.9278L18.3783 15.5063C18.4609 14.9725 18.6696 14.4674 18.9897 14.031L19.8398 12.872C20.2211 12.3532 20.2211 11.6468 19.8398 11.1292L18.9897 9.96898C18.6708 9.53319 18.4612 9.02728 18.3783 8.49369L18.1608 7.07342C18.1131 6.76322 17.9678 6.47631 17.7459 6.2544C17.524 6.03248 17.2371 5.88711 16.9269 5.83942L15.5055 5.62188C14.9719 5.53902 14.466 5.32936 14.0303 5.01051L12.8714 4.16035ZM10.6498 9.60641C10.5376 9.82691 10.344 9.99412 10.109 10.0716C9.87407 10.1491 9.61801 10.1305 9.39665 10.02C9.17529 9.90947 9.00659 9.71594 8.9273 9.48156C8.84801 9.24719 8.86456 8.99097 8.97335 8.76875C9.18463 8.34491 9.51842 7.89233 10.0347 7.54726C10.5573 7.19969 11.2111 6.99965 12 6.99965C12.7351 6.99471 13.4525 7.22468 14.0478 7.65603C14.6754 8.12737 15.1254 8.86251 15.1254 9.8127C15.1254 10.3728 14.9816 10.8504 14.7141 11.2505C14.4578 11.6343 14.1265 11.8919 13.849 12.0781C13.7127 12.1682 13.574 12.2507 13.4577 12.3219L13.4502 12.3269C13.3402 12.3909 13.2318 12.4576 13.1251 12.527C12.9921 12.6068 12.8751 12.7107 12.7801 12.8333C12.6409 13.0372 12.4269 13.178 12.1845 13.2251C11.9422 13.2722 11.691 13.2218 11.4856 13.0848C11.2802 12.9479 11.1371 12.7354 11.0873 12.4936C11.0376 12.2517 11.0852 12 11.2199 11.7931C11.4499 11.463 11.745 11.1817 12.085 10.9667C12.2213 10.8754 12.36 10.7929 12.4763 10.7229L12.4851 10.7179C12.6101 10.6416 12.7126 10.5803 12.8076 10.5166C12.9411 10.4369 13.0585 10.333 13.1539 10.2103C13.2002 10.1428 13.2502 10.034 13.2502 9.8127C13.2551 9.68458 13.2277 9.55727 13.1705 9.44254C13.1132 9.32781 13.028 9.22937 12.9226 9.15632C12.6517 8.96914 12.3293 8.87083 12 8.87502C11.5387 8.87502 11.2562 8.98754 11.0749 9.10881C10.8915 9.23399 10.7448 9.40574 10.6498 9.60641ZM13.2502 15.7514C13.2502 16.0829 13.1185 16.4009 12.884 16.6354C12.6495 16.8699 12.3316 17.0016 12 17.0016C11.6684 17.0016 11.3505 16.8699 11.116 16.6354C10.8815 16.4009 10.7498 16.0829 10.7498 15.7514C10.7498 15.4198 10.8815 15.1018 11.116 14.8673C11.3505 14.6328 11.6684 14.5011 12 14.5011C12.3316 14.5011 12.6495 14.6328 12.884 14.8673C13.1185 15.1018 13.2502 15.4198 13.2502 15.7514Z"
                                //     fill="#FEAE01"
                                //   />
                                // </svg>
                                <img width="24" height="24" src="https://img.icons8.com/color/80/delete-sign--v1.png" alt="delete-sign--v1" />
                            }

                            <div>E-mail</div>
                          </div>
                          <div className="email-box display-1 text-center">
                            {
                              userData?.Kycs?.status === '0' ?
                                <svg
                                  width="24"
                                  height="24"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M10.0185 2.6488C10.5932 2.22728 11.2873 2 12 2C12.7127 2 13.4068 2.22728 13.9815 2.6488L15.1417 3.49897C15.3329 3.64025 15.5542 3.73151 15.7893 3.76777L17.2119 3.98656C17.916 4.09491 18.5671 4.42484 19.0709 4.92843C19.5747 5.43203 19.9049 6.08309 20.0136 6.78711L20.2323 8.20989C20.2686 8.44368 20.3599 8.66623 20.5011 8.85751L21.3512 10.0177C21.7727 10.5925 22 11.2866 22 11.9994C22 12.7121 21.7727 13.4063 21.3512 13.981L20.5011 15.1412C20.3616 15.3329 20.2695 15.5548 20.2323 15.7889L20.0136 17.2116C19.9051 17.9159 19.5751 18.5672 19.0713 19.0711C18.5674 19.5749 17.9161 19.905 17.2119 20.0134L15.7893 20.2322C15.5552 20.2694 15.3333 20.3615 15.1417 20.501L13.9815 21.3512C13.4068 21.7727 12.7127 22 12 22C11.2873 22 10.5932 21.7727 10.0185 21.3512L8.85833 20.501C8.66673 20.3615 8.44481 20.2694 8.21075 20.2322L6.78681 20.0147C6.08302 19.9061 5.43213 19.5761 4.92858 19.0725C4.42503 18.5689 4.09503 17.918 3.98644 17.2141L3.76766 15.7914C3.73048 15.5573 3.63836 15.3354 3.49887 15.1437L2.64876 13.9835C2.22726 13.4088 2 12.7146 2 12.0019C2 11.2891 2.22726 10.595 2.64876 10.0202L3.49887 8.86001C3.63836 8.6684 3.73048 8.44646 3.76766 8.21239L3.98644 6.78711C4.09503 6.08327 4.42503 5.43234 4.92858 4.92876C5.43213 4.42519 6.08302 4.09516 6.78681 3.98656L8.2095 3.76777C8.44328 3.73151 8.66581 3.64025 8.85708 3.49897L10.0185 2.6488ZM12.8714 4.16035C12.6185 3.97526 12.3133 3.87548 12 3.87548C11.6867 3.87548 11.3815 3.97526 11.1286 4.16035L9.96848 5.01051C9.53272 5.32936 9.02684 5.53902 8.49329 5.62188L7.0731 5.83942C6.76292 5.88711 6.47603 6.03248 6.25413 6.2544C6.03223 6.47631 5.88687 6.76322 5.83918 7.07342L5.62166 8.49494C5.5388 9.02853 5.32916 9.53444 5.01032 9.97023L4.16021 11.1292C3.77891 11.6481 3.77891 12.3544 4.16021 12.872L5.01032 14.0323C5.33037 14.4674 5.53914 14.9725 5.62166 15.5076L5.83918 16.9278C5.9367 17.5655 6.43676 18.0643 7.0731 18.1618L8.49454 18.3794C9.02836 18.4619 9.53342 18.6707 9.96973 18.9907L11.1286 19.8409C11.6475 20.2222 12.3538 20.2222 12.8714 19.8409L14.0315 18.9907C14.4673 18.6719 14.9732 18.4622 15.5067 18.3794L16.9269 18.1618C17.5645 18.0643 18.0633 17.5642 18.1608 16.9278L18.3783 15.5063C18.4609 14.9725 18.6696 14.4674 18.9897 14.031L19.8398 12.872C20.2211 12.3532 20.2211 11.6468 19.8398 11.1292L18.9897 9.96898C18.6708 9.53319 18.4612 9.02728 18.3783 8.49369L18.1608 7.07342C18.1131 6.76322 17.9678 6.47631 17.7459 6.2544C17.524 6.03248 17.2371 5.88711 16.9269 5.83942L15.5055 5.62188C14.9719 5.53902 14.466 5.32936 14.0303 5.01051L12.8714 4.16035ZM10.6498 9.60641C10.5376 9.82691 10.344 9.99412 10.109 10.0716C9.87407 10.1491 9.61801 10.1305 9.39665 10.02C9.17529 9.90947 9.00659 9.71594 8.9273 9.48156C8.84801 9.24719 8.86456 8.99097 8.97335 8.76875C9.18463 8.34491 9.51842 7.89233 10.0347 7.54726C10.5573 7.19969 11.2111 6.99965 12 6.99965C12.7351 6.99471 13.4525 7.22468 14.0478 7.65603C14.6754 8.12737 15.1254 8.86251 15.1254 9.8127C15.1254 10.3728 14.9816 10.8504 14.7141 11.2505C14.4578 11.6343 14.1265 11.8919 13.849 12.0781C13.7127 12.1682 13.574 12.2507 13.4577 12.3219L13.4502 12.3269C13.3402 12.3909 13.2318 12.4576 13.1251 12.527C12.9921 12.6068 12.8751 12.7107 12.7801 12.8333C12.6409 13.0372 12.4269 13.178 12.1845 13.2251C11.9422 13.2722 11.691 13.2218 11.4856 13.0848C11.2802 12.9479 11.1371 12.7354 11.0873 12.4936C11.0376 12.2517 11.0852 12 11.2199 11.7931C11.4499 11.463 11.745 11.1817 12.085 10.9667C12.2213 10.8754 12.36 10.7929 12.4763 10.7229L12.4851 10.7179C12.6101 10.6416 12.7126 10.5803 12.8076 10.5166C12.9411 10.4369 13.0585 10.333 13.1539 10.2103C13.2002 10.1428 13.2502 10.034 13.2502 9.8127C13.2551 9.68458 13.2277 9.55727 13.1705 9.44254C13.1132 9.32781 13.028 9.22937 12.9226 9.15632C12.6517 8.96914 12.3293 8.87083 12 8.87502C11.5387 8.87502 11.2562 8.98754 11.0749 9.10881C10.8915 9.23399 10.7448 9.40574 10.6498 9.60641ZM13.2502 15.7514C13.2502 16.0829 13.1185 16.4009 12.884 16.6354C12.6495 16.8699 12.3316 17.0016 12 17.0016C11.6684 17.0016 11.3505 16.8699 11.116 16.6354C10.8815 16.4009 10.7498 16.0829 10.7498 15.7514C10.7498 15.4198 10.8815 15.1018 11.116 14.8673C11.3505 14.6328 11.6684 14.5011 12 14.5011C12.3316 14.5011 12.6495 14.6328 12.884 14.8673C13.1185 15.1018 13.2502 15.4198 13.2502 15.7514Z"
                                    fill="#FEAE01"
                                  />
                                </svg> :
                                userData?.Kycs?.status === '1' ?
                                  <svg
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      fillRule="evenodd"
                                      clipRule="evenodd"
                                      d="M3.43934 4.18934C3.72064 3.90804 4.10217 3.75 4.5 3.75H19.5C19.8978 3.75 20.2794 3.90804 20.5607 4.18934C20.842 4.47065 21 4.85218 21 5.25V10.7531C21 19.1427 13.8772 21.9192 12.4804 22.3836C12.1698 22.4948 11.8302 22.4948 11.5196 22.3836C10.1228 21.9192 3 19.1427 3 10.7531V5.25C3 4.85217 3.15804 4.47064 3.43934 4.18934ZM19.5 5.25L4.5 5.25L4.5 10.7531C4.5 18.0901 10.706 20.534 12 20.9626C13.294 20.534 19.5 18.0901 19.5 10.7531V5.25Z"
                                      fill="#06B470"
                                    />
                                    <path
                                      fillRule="evenodd"
                                      clipRule="evenodd"
                                      d="M16.6677 9.2323C16.9536 9.532 16.9424 10.0067 16.6427 10.2927L11.1396 15.5427C10.8496 15.8193 10.3934 15.8191 10.1037 15.5422L7.35684 12.9172C7.05738 12.631 7.0466 12.1563 7.33278 11.8568C7.61895 11.5574 8.0937 11.5466 8.39317 11.8328L10.6223 13.963L15.6073 9.20734C15.907 8.92142 16.3817 8.93259 16.6677 9.2323Z"
                                      fill="#06B470"
                                    />
                                  </svg> :
                                  // <svg
                                  //   width="24"
                                  //   height="24"
                                  //   viewBox="0 0 24 24"
                                  //   fill="none"
                                  //   xmlns="http://www.w3.org/2000/svg"
                                  // >
                                  //   <path
                                  //     fillRule="evenodd"
                                  //     clipRule="evenodd"
                                  //     d="M3.43934 4.18934C3.72064 3.90804 4.10217 3.75 4.5 3.75H19.5C19.8978 3.75 20.2794 3.90804 20.5607 4.18934C20.842 4.47065 21 4.85218 21 5.25V10.7531C21 19.1427 13.8772 21.9192 12.4804 22.3836C12.1698 22.4948 11.8302 22.4948 11.5196 22.3836C10.1228 21.9192 3 19.1427 3 10.7531V5.25C3 4.85217 3.15804 4.47064 3.43934 4.18934ZM19.5 5.25L4.5 5.25L4.5 10.7531C4.5 18.0901 10.706 20.534 12 20.9626C13.294 20.534 19.5 18.0901 19.5 10.7531V5.25Z"
                                  //     fill="#06B470"
                                  //   />
                                  //   <path
                                  //     fillRule="evenodd"
                                  //     clipRule="evenodd"
                                  //     d="M16.6677 9.2323C16.9536 9.532 16.9424 10.0067 16.6427 10.2927L11.1396 15.5427C10.8496 15.8193 10.3934 15.8191 10.1037 15.5422L7.35684 12.9172C7.05738 12.631 7.0466 12.1563 7.33278 11.8568C7.61895 11.5574 8.0937 11.5466 8.39317 11.8328L10.6223 13.963L15.6073 9.20734C15.907 8.92142 16.3817 8.93259 16.6677 9.2323Z"
                                  //     fill="#06B470"
                                  //   />
                                  // </svg>
                                  <img width="24" height="24" src="https://img.icons8.com/color/80/delete-sign--v1.png" alt="delete-sign--v1" />
                            }
                            <div>KYC</div>
                          </div>
                        </div>
                      </div>
                      <div className="profile-change display-2">
                        <div className="total-assets">
                          <p>Total Assets</p>
                          <div className="coin-value display-1">
                            {/* <span>0</span> */}
                            <div className='wallet-balance display-2 gap'>
                              {show ? '0.00' : '*****'} {!show ? <VisibilityOffIcon onClick={(() => { setShow(!show) })} className='cursor' /> : <VisibilityIcon onClick={(() => { setShow(!show) })} className='cursor' />}
                            </div>
                            <NativeSelect
                              defaultValue={10}
                              inputProps={{
                                name: "age",
                                id: "uncontrolled-native",
                              }}
                            >
                              <option value={10}>USDT</option>
                              <option value={20}>BTC</option>
                              <option value={30}>KCS</option>
                            </NativeSelect>
                          </div>
                          <span>~0.00</span>
                        </div>
                        <div className="assets-overview">
                          <div className="assets-order display-1">
                            {/* <Link to="">Assets Overview</Link> */}
                            <Link to="">Orders</Link>
                          </div>
                          <div className="assets-order display-1 deposit-btn">
                            <Link to="" className="active">
                              Buy Crypto
                            </Link>
                            <Link to="/wallet" className="">
                              Deposit
                            </Link>
                            <Link to="/wallet" className="">
                              Withdraw
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="dashboard-full">
                      <h2>Two-Factor Authentication (2FA)</h2>
                      <p className="two-fa">
                        Choose [Google Verification + Email + Trading Password] or
                        [Mobile Phone + Trading Password] to ensure the safety of
                        your assets.
                      </p>
                      <Grid container>
                        <Grid xs={12} sm={12} md={12} lg={12} xl={12}>
                          <div className="email-box-auth display-2">
                            {/* <div>
                              <h5>Email</h5>
                              <p>
                                Used to verify withdrawals, API creation, etc.
                              </p>
                            </div> */}
                            {/* <div>
                              <div className="enable-disable display-1">
                                <Button
                                  onClick={() => {
                                    handleEmailOpen();
                                  }}
                                  className="green-border"
                                >
                                  Enable
                                </Button>
                                <Button className="red-border">Disable</Button>
                              </div>

                              <Modal
                                open={EmailModal}
                                onClose={handleEmailClose}
                                aria-labelledby="modal-modal-title"
                                aria-describedby="modal-modal-description"
                              >
                                <Box className="id-popup">
                                  <div
                                    className="close-menu text-end cursor"
                                    onClick={() => {
                                      handleEmailClose();
                                    }}
                                  >
                                    <CloseIcon />
                                  </div>
                                  <Typography
                                    id="modal-modal-title"
                                    variant="h6"
                                    component="h2"
                                  >
                                    EMAIL AUTHENTICATION
                                  </Typography>
                                  <Typography
                                    id="modal-modal-description"
                                    sx={{ mt: 2, paddingBottom: "15px" }}
                                  >
                                    Send 2FA code via Email
                                  </Typography>
                                  <Link to="" sx={{ mt: 1 }}>
                                    Click to send E-mail OTP
                                  </Link>

                                  <div className="code-box">
                                    <label>Enter your code</label>
                                    <TextField fullWidth id="fullWidth" />
                                  </div>
                                  <div className="submit-btn text-center">
                                    <Button sx={{ mt: 2, paddingBottom: "15px" }}>
                                      Submit
                                    </Button>
                                  </div>
                                </Box>
                              </Modal>
                            </div> */}
                          </div>
                          <div className="email-box-auth display-2">
                            <div>
                              <h5>2FA Verification</h5>
                              <p>For secure login.</p>
                            </div>
                            <div>
                              <div className="enable-disable display-1">
                                {
                                  userData.f2A_Status === 'false' ?
                                    <Button
                                      onClick={() => {
                                        handleGoogleOpen();
                                        generate2fa();
                                      }}
                                      className="green-border"
                                    >
                                      Enable
                                    </Button> : <></>
                                }
                                {
                                  userData?.f2A_Status === 'true' ?
                                    <Button className="red-border" onClick={() => { handleDisableGoogleOpen() }}>Disable</Button>
                                    : <></>
                                }
                              </div>
                              {/* <Button onClick={()=>{handleGoogleOpen()}}>Enable</Button> */}
                              <Modal
                                open={GoogleModal}
                                onClose={handleGoogleClose}
                                aria-labelledby="modal-modal-title"
                                aria-describedby="modal-modal-description"
                              >
                                <Box className="id-popup" sx={{ overflowY: 'auto' }} >
                                  <div
                                    className="close-menu text-end cursor"
                                    onClick={() => {
                                      handleGoogleClose();
                                    }}
                                  >
                                    <CloseIcon />
                                  </div>
                                  <Typography
                                    id="modal-modal-title"
                                    variant="h6"
                                    component="h2"
                                  >
                                    Google Authentication
                                  </Typography>
                                  <Typography
                                    id="modal-modal-description"
                                    sx={{ mt: 2, paddingBottom: "15px" }}
                                  >
                                    Install google autheticator app in your mobile
                                    and scan QR Code (or) If you are unable to
                                    scan the QR code, please enter this code
                                    manually into the app
                                  </Typography>

                                  <div className="code-box">
                                    <Box
                                      sx={{
                                        display: "flex",
                                        flexDirection: "row",
                                      }}
                                    >
                                      <TextField
                                        variant="outlined"
                                        fullWidth
                                        // defaultValue={defaultText}
                                        value={secret}
                                      />
                                      <Button
                                        onClick={() => {
                                          handleCopy();
                                        }}
                                      >
                                        <ContentCopyIcon />
                                      </Button>
                                      {copied && (
                                        <Typography
                                          variant="body2"
                                          color="success.main"
                                        >
                                          Copied!
                                        </Typography>
                                      )}
                                    </Box>
                                  </div>
                                  <div className="code-box">
                                    <label>Enter your code</label>
                                    <TextField fullWidth id="fullWidth" value={otp} type="number"
                                      onChange={(e) => { setOtp(e.target.value) }} />

                                    <div className="qr-code">
                                      {/* <img src={Qr} /> */}
                                      <QRCodeSVG value={qrCode}
                                        includeMargin={true} />
                                    </div>
                                  </div>
                                  <div className="submit-btn text-center">
                                    {
                                      load ?
                                        <Button sx={{ mt: 2, paddingBottom: "15px" }}>
                                          Processing...
                                        </Button> :
                                        <Button sx={{ mt: 2, paddingBottom: "15px" }} onClick={() => { verify2fa() }}>
                                          Submit
                                        </Button>
                                    }

                                  </div>
                                </Box>
                              </Modal>

                              <Modal
                                open={DisableGoogleModal}
                                onClose={handleDisableGoogleClose}
                                aria-labelledby="modal-modal-title"
                                aria-describedby="modal-modal-description"
                              >
                                <Box className="id-popup">
                                  <div
                                    className="close-menu text-end cursor"
                                    onClick={() => {
                                      handleDisableGoogleClose();
                                    }}
                                  >
                                    <CloseIcon />
                                  </div>
                                  <Typography
                                    id="modal-modal-title"
                                    variant="h6"
                                    component="h2"
                                  >
                                    Diable Google Authentication
                                  </Typography>

                                  <div className="code-box">
                                    <label>Enter your code</label>
                                    <TextField fullWidth id="fullWidth" value={otp}
                                      onChange={(e) => { setOtp(e.target.value) }} />

                                  </div>
                                  <div className="submit-btn text-center">
                                    {
                                      load ?
                                        <Button sx={{ mt: 2, paddingBottom: "15px" }}>
                                          Processing...
                                        </Button> :
                                        <Button sx={{ mt: 2, paddingBottom: "15px" }} onClick={() => { diable2fa() }}>
                                          Submit
                                        </Button>
                                    }

                                  </div>
                                </Box>
                              </Modal>
                            </div>
                          </div>
                          <div className="email-box-auth display-2">
                            <div>
                              <h5>Login Password</h5>
                              <p>For account login.</p>
                            </div>
                            <div>
                              <Button
                                onClick={() => {
                                  handlePasswordOpen();
                                }}
                              >
                                Change
                              </Button>

                              <Modal
                                open={PasswordModal}
                                // onClose={handlePasswordClose}
                                aria-labelledby="modal-modal-title"
                                aria-describedby="modal-modal-description"
                              >
                                <Box className="id-popup">
                                  <div
                                    className="close-menu text-end cursor"
                                    onClick={() => {
                                      handlePasswordClose();
                                    }}
                                  >
                                    <CloseIcon />
                                  </div>
                                  <Grid>
                                    <Grid
                                      item
                                      xs={12}
                                      sm={12}
                                      md={12}
                                      lg={12}
                                      xl={12}
                                    >
                                      <Grid>
                                        <Grid
                                          item
                                          xs={12}
                                          sm={10}
                                          md={9}
                                          lg={12}
                                          xl={12}
                                        >
                                          <Box className="reset-modal">
                                            <Typography
                                              component="h1"
                                              variant="h5"
                                              className="text-center c-accout"
                                              sx={{ mt: 1, mb: 3 }}
                                            >
                                              Reset Password
                                            </Typography>
                                            <Box
                                              // component="form"
                                              noValidate
                                              sx={{ mt: 1 }}
                                            >
                                              <div
                                                className="email-fill "
                                                style={{ marginTop: "10px" }}
                                              >
                                                <div className="email-name">
                                                  Old Password
                                                </div>
                                                <FormControl
                                                  sx={{ mt: 1, width: "100%" }}
                                                  variant="outlined"
                                                >
                                                  {/* <InputLabel htmlFor="outlined-adornment-password">Password</InputLabel> */}
                                                  <OutlinedInput
                                                    id="outlined-adornment-password"
                                                    type={
                                                      showPassword
                                                        ? "text"
                                                        : "password"
                                                    }
                                                    value={oldPass}
                                                    onChange={(e) => { setOldPass(e.target.value) }}
                                                    endAdornment={
                                                      <InputAdornment position="end">
                                                        <IconButton
                                                          // aria-label={
                                                          //   showPassword
                                                          //     ? "hide the password"
                                                          //     : "display the password"
                                                          // }
                                                          onClick={() => {
                                                            handleClickShowPassword();
                                                          }}
                                                          edge="end"
                                                        >
                                                          {/* <div   onClick={ ()=>  handleClickShowPassword()}> */}
                                                          {!showPassword ? (
                                                            <VisibilityOff />
                                                          ) : (
                                                            <Visibility />
                                                          )}
                                                          {/* </div> */}
                                                        </IconButton>
                                                      </InputAdornment>
                                                    }
                                                  />
                                                </FormControl>
                                              </div>

                                              <div
                                                className="email-fill "
                                                style={{ marginTop: "10px" }}
                                              >
                                                <div className="email-name">
                                                  New Password
                                                </div>
                                                <FormControl
                                                  sx={{ mt: 1, width: "100%" }}
                                                  variant="outlined"
                                                >
                                                  <OutlinedInput
                                                    id="outlined-adornment-password"
                                                    type={
                                                      showNewPassword
                                                        ? "text"
                                                        : "password"
                                                    }
                                                    value={NewPass}
                                                    onChange={(e) => { setNewPass(e.target.value) }}
                                                    endAdornment={
                                                      <InputAdornment position="end">
                                                        <IconButton
                                                          onClick={() => {
                                                            handleClickNewShowPassword();
                                                          }}
                                                          edge="end"
                                                        >
                                                          {!showNewPassword ? (
                                                            <VisibilityOff />
                                                          ) : (
                                                            <Visibility />
                                                          )}
                                                          {/* </div> */}
                                                        </IconButton>
                                                      </InputAdornment>
                                                    }
                                                  />
                                                </FormControl>
                                              </div>

                                              <div
                                                className="email-fill "
                                                style={{ marginTop: "10px" }}
                                              >
                                                <div className="email-name">
                                                  Confirm Password
                                                </div>
                                                <FormControl
                                                  sx={{ mt: 1, width: "100%" }}
                                                  variant="outlined"
                                                >
                                                  {/* <InputLabel htmlFor="outlined-adornment-password">Password</InputLabel> */}
                                                  <OutlinedInput
                                                    id="outlined-adornment-password"
                                                    type={
                                                      showConfirmPassword
                                                        ? "text"
                                                        : "password"
                                                    }
                                                    value={ConfirmPass}
                                                    onChange={(e) => { setConfirmPass(e.target.value) }}
                                                    endAdornment={
                                                      <InputAdornment position="end">
                                                        <IconButton
                                                          onClick={() => {
                                                            handleClickConfirmShowPassword();
                                                          }}
                                                          edge="end"
                                                        >
                                                          {!showConfirmPassword ? (
                                                            <VisibilityOff />
                                                          ) : (
                                                            <Visibility />
                                                          )}
                                                        </IconButton>
                                                      </InputAdornment>
                                                    }
                                                  />
                                                </FormControl>
                                              </div>

                                              <div className="login-btn">
                                                {
                                                  load ?
                                                    <Button
                                                      type="submit"
                                                      fullWidth
                                                      sx={{ mt: 3, mb: 2 }}
                                                    >
                                                      Processing...
                                                    </Button> :
                                                    <Button
                                                      type="submit"
                                                      fullWidth
                                                      sx={{ mt: 3, mb: 2 }}
                                                      onClick={() => { changePassword() }}
                                                    >
                                                      Reset
                                                    </Button>

                                                }

                                              </div>
                                            </Box>
                                          </Box>
                                        </Grid>
                                      </Grid>
                                    </Grid>
                                  </Grid>
                                </Box>
                              </Modal>
                            </div>
                          </div>
                        </Grid>
                      </Grid>
                    </div>
                  </Grid>
                </Grid>
              </CustomTabPanel>

              <CustomTabPanel value={value} index={1} className="tab-box">
                <div className="dashboard-full kyc-verify kyc-encrypted">
                  <div className="display-2">
                    <div>
                      <h2>Standard Identity Verification</h2>
                      <p>It only takes 3-5 minutes to verify your account.</p>
                      <p>
                        Verified accounts have stronger protection against fraud
                        and malicious actors.
                      </p>

                      <div className="kyc-verify">
                        <Button onClick={() => {
                          navigate("/kyc", { state: userData });
                        }}
                        >
                          Verify <ArrowForwardIcon />
                        </Button>
                      </div>
                    </div>

                    <div className="kyc-img">
                      <img src={kyc} />
                    </div>
                  </div>
                  <div className="encrypt-code display-1">
                    <VerifiedUserOutlinedIcon />
                    <p>Your information on Kaavi is encrypted.</p>
                  </div>
                </div>
              </CustomTabPanel>
            </Grid>
          </Grid>
        </div>
      </div>
    </>
  );
};

export default Profile;
